import React from 'react';
import Button from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  const handleLearnMission = () => {
    navigate('/mission');
  };

  const handleSupportNow = () => {
    navigate('/donate');
  };

  return (
    <>
      <section 
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/cb57e98cafc9f65751a1e5354efd5169.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/9842b5143901a0019f067b22648287f2/6dc28083c333cd2e87fecc39fbcc10b7.jfif')`,
          }}
        >
          <div className="absolute inset-0 bg-white/90"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <div className="max-w-4xl mx-auto space-y-8">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#111111] leading-tight">
              Oxygen is Life.
              <br />
              <span className="text-[#12B6B6]">We Exist to Protect It.</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
              Diatomic Life Foundation is a Section-8 non-profit working to solve the oxygen deficiency crisis through prevention, awareness, and access.
            </p>

            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              We help people understand their oxygen health, detect risk early, and access safe oxygen support when needed.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <Button
                  variant="primary"
                  size="lg"
                  className="bg-[#12B6B6] hover:bg-[#0ea5a5] shadow-lg hover:shadow-xl px-10"
                  onClick={handleLearnMission}
                >
                  Learn Our Mission
                </Button>
                <Button
                  variant="secondary"
                  size="lg"
                  className="bg-[#111111] text-white hover:bg-gray-800 shadow-lg hover:shadow-xl px-10"
                  onClick={handleSupportNow}
                >
                  Support Now
                </Button>
              </div>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-16 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-[#12B6B6]">200+</div>
                <div className="text-sm text-gray-600 mt-1">Conditions Linked</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-[#12B6B6]">1,000+</div>
                <div className="text-sm text-gray-600 mt-1">Beneficiaries</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-[#12B6B6]">15</div>
                <div className="text-sm text-gray-600 mt-1">Districts in Pipeline</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-2xl text-[#12B6B6]"></i>
        </div>
      </section>

      {/* Trust Strip */}
      <div className="w-full bg-[#12B6B6] py-4">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12">
            <div className="flex items-center gap-2 text-white font-medium">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-government-line text-lg"></i>
              </div>
              <span className="text-sm font-semibold tracking-wide">Section-8 Non-Profit</span>
            </div>
            <div className="hidden sm:block w-px h-5 bg-white/40"></div>
            <div className="flex items-center gap-2 text-white font-medium">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shield-check-line text-lg"></i>
              </div>
              <span className="text-sm font-semibold tracking-wide">80G Tax Exemption Available</span>
            </div>
            <div className="hidden sm:block w-px h-5 bg-white/40"></div>
            <div className="flex items-center gap-2 text-white font-medium">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-bar-chart-line text-lg"></i>
              </div>
              <span className="text-sm font-semibold tracking-wide">Transparent Impact Reporting</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
